module.exports = __WEBPACK_EXTERNAL_MODULE_266__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/events/TouchEvent","root":["openfl","events","TouchEvent"],"commonjs":"openfl/events/TouchEvent","commonjs2":"openfl/events/TouchEvent"}
// module id = 266
// module chunks = 0